export const shortenUrl = (url: string, maxLength = 30): string => {
  try {
    const parsedUrl = new URL(url);
    const domain = parsedUrl.hostname;
    const path = parsedUrl.pathname;
    const lastPart = path.split("/").filter(Boolean).pop() || "";

    if (domain.length + lastPart.length > maxLength) {
      return `${domain.substring(0, 20)}.../${lastPart.substring(0, 10)}`;
    }

    return `${domain}${lastPart ? `/${lastPart}` : ""}`;
  } catch {
    return url; // Return original if invalid URL
  }
};
